import { Route, Routes } from 'react-router-dom';
import React from 'react';
import SrikandiList from './List';
import SrikandiEdit from './Edit';
import SrikandiSales from '../Sales';

const SrikandiPage = () => {
  return (
    <Routes>
      <Route path="/" element={<SrikandiList />} />
      <Route path=":userId/edit" element={<SrikandiEdit />} />
      <Route path=":userId/sales" element={<SrikandiSales />} />
    </Routes>
  );
};

export default SrikandiPage;
